import Component from '@glimmer/component';
import 'mewe/assets/styles/scss/_error-pages.scss';

export default class UnsubscribeRoute extends Component {};